import dayjs from "dayjs";
import { FC } from "react";
import { useParams } from "react-router-dom";
import ListState from "../../components/scan/ListState";
import PassengerCard, { BOARDING_STATUS, bookedElsewhere, namesOf } from "../../components/scan/PassengerCard";
import Back from "../../components/ui/Back";
import Status from "../../components/ui/Status";
import Table, { Row } from "../../components/ui/table";
import usePolling from "../../hooks/usePolling";
import useWindowSize from "../../hooks/useWindowResize";
import { getDeparturePassengers } from "../../services/Boarding.service";

const POLL_MS = 5000;

const columns = ["ID e rezervimit", "Udhëtarët", "Nr.", "Statusi", "Ora e skanimit", "Nisja e rezervuar"];

const DeparturePassengers: FC = () => {
  const { tripId = "", date = "" } = useParams();
  const { data, failed, reload } = usePolling(
    () => getDeparturePassengers(Number(tripId), date).then((r) => r.data),
    POLL_MS,
    [tripId, date]
  );
  const { sm, md, lg } = useWindowSize();
  const phone = sm || md || lg;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center gap-x-3">
        <Back
          to={`/scan/departures?date=${date}`}
          state={{ crumbs: ["Kontrolli i biletave", "Udhëtarët"] }}
          title="Udhëtarët"
          className="min-h-[44px] md:-ml-4"
        />
        {data && (
          <h2 className="text-lg font-semibold">
            {dayjs(data.departure).format("DD.MM.YYYY HH:mm")}
            {` · ${data.from} → ${data.to}`}
          </h2>
        )}
      </div>
      {phone ? (
        <div className="flex flex-col gap-3">
          {data?.bookings.map((booking) => <PassengerCard key={booking.ticketId} booking={booking} />)}
        </div>
      ) : (
        <Table titles={columns} style="hover" loading={!data && !failed}>
          {data?.bookings.map((booking) => {
            const names = namesOf(booking);
            return (
              <Row
                key={booking.ticketId}
                reference={booking.bookingReference}
                names={<span className="block max-w-[14rem] truncate" title={names}>{names}</span>}
                count={booking.passengerCount}
                status={<Status {...BOARDING_STATUS[booking.statusCode]} />}
                boardedAt={booking.boardedAt ? dayjs(booking.boardedAt).format("HH:mm") : "—"}
                booked={bookedElsewhere(booking)
                  ? dayjs(booking.bookedDeparture).format("HH:mm")
                  : "Kjo nisje"}
              />
            );
          }) ?? []}
        </Table>
      )}
      <ListState
        loading={!data}
        failed={failed}
        empty={!!data && !data.bookings.length}
        emptyText="Nuk ka udhëtarë për këtë nisje"
        phone={phone}
        onRetry={reload}
      />
    </div>
  );
};

export default DeparturePassengers;
